import { TableCell, TableRow } from "@material-ui/core";
import { memo } from "react";
import MaskService from "../../../../../utils/mask/maskService";

const ConsolidatedReportTableRow = ({ cell, columns, level }) => {
  return (
    <TableRow>
      <TableCell
        align="left"
        colSpan={columns.length - 5}
        style={{ paddingLeft: level * 16, backgroundColor: "#eaf2ff" }}
      >
        {cell.group?.description}
      </TableCell>

      <TableCell align="right" style={{ backgroundColor: "#eaf2ff" }}>
        {`${cell?.total?.debit < 0 ? " - " : ""} ${MaskService.toMask(
          "decimal",
          parseFloat(cell?.total?.debit ?? "0,00").toFixed(2),
          2
        )}`}
      </TableCell>

      <TableCell align="left" style={{ backgroundColor: "#eaf2ff" }}>
        {cell?.total?.debitPerCent ?? 0}
      </TableCell>

      <TableCell align="right" style={{ backgroundColor: "#eaf2ff" }}>
        {`${cell?.total?.credit < 0 ? " - " : ""} ${MaskService.toMask(
          "decimal",
          parseFloat(cell?.total?.credit ?? "0,00").toFixed(2),
          2
        )}`}
      </TableCell>

      <TableCell align="left" style={{ backgroundColor: "#eaf2ff" }}>
        {cell?.total?.creditPerCent ?? 0}
      </TableCell>

      <TableCell align="right" style={{ backgroundColor: "#eaf2ff" }}>
        {`${cell?.total?.balance < 0 ? " - " : ""} ${MaskService.toMask(
          "decimal",
          parseFloat(cell?.total?.balance ?? "0,00").toFixed(2),
          2
        )}`}
      </TableCell>
    </TableRow>
  );
};

export default memo(ConsolidatedReportTableRow);
